import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'payment-identification-header',
    templateUrl: './payment.identification.header.component.html'
})
export class PaymentIdentificationHeaderComponent {
    @Output() activated: EventEmitter<null> = new EventEmitter();

    /**
     * resetedIdentifiedToken event listener.
     **/
    public onResetedIdentifiedUser() {
        this.activated.emit();
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/payment/identification/header/payment.identification.header.component.ts